export default "__VITE_ASSET__CDb31Swd__"